<template>
  <div class="home">
    <div class="flex content-center mt-40">
      <div class="text-left flex-grow">
        <h3 class="font-extrabold text-black text-3xl">Hello, I'm Dimas Adi.</h3>
        <p class="pt-4">A <a class="text-teal-500">web developer & student</a> who is enthusiastic <br/>about technological developments.</p>
        <button onclick="location.href='https://www.linkedin.com/in/dimas-a-9b2532139/'" class="bg-black .button hover:bg-white hover:text-black border hover:border-black text-white font-bold py-4 mt-6 px-8 inline-flex items-center">
          About Me
        </button>
      </div>
      <div class="flex-grow h3 mt-8 ml-2 text-white text-left">
        <h3 class="text-6xl tracking-widest">KEEP</h3>
        <h3 class="text-6xl tracking-widest">MOVING</h3>
        <h3 class="text-6xl tracking-widest">FORWARD</h3>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {}
};
</script>

<style lang="scss" scoped>
  .h3 {
  color: white;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke-width: 0.8px;
  -webkit-text-stroke-color: white;
  text-shadow:
    -1px -1px 0 transparent,  
    1px -1px 0 transparent,
    -1px 1px 0 transparent,
    1px 1px 0 transparent;
  line-height: 0.6;
  font-family: "inter Extra Bold";
}
</style>
